import { Routes } from "../../navigation/routes";
import PageHeader from "ui/components/PageHeader/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Breadcrumb } from "ui/components/Breadcrumb";
import { NOTIFICATION_CALENDAR_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { TabMenu } from "../components/TabMenu";
import { VehicleTimelineView } from "./components/VehicleTimeline";

type NotificationVehicleTimelinePageCmp = React.FC & { route: string };

const NotificationVehicleTimelinePage: NotificationVehicleTimelinePageCmp = () => {
  return (
    <div>
      <div className="bg-white rounded-t-md">
        <PageHeader>
          <PageTitle
            title={NOTIFICATION_CALENDAR_PAGE_TITLE.text}
            icon={NOTIFICATION_CALENDAR_PAGE_TITLE.icon}
            iconColor={NOTIFICATION_CALENDAR_PAGE_TITLE.iconColor}
          />
          <Breadcrumb />
        </PageHeader>
        <TabMenu />
      </div>

      <div className="px-4 py-4">
        <VehicleTimelineView />
      </div>
    </div>
  );
};

NotificationVehicleTimelinePage.route = Routes.NotificationVehicleTimelinePageRouter;

export default NotificationVehicleTimelinePage;
